"use client"

import type React from "react"

import { useState, useEffect } from "react"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Link } from "react-router-dom"


interface SaveReportModalProps {
  isOpen?: boolean
  onOpenChange?: (open: boolean) => void
  onContinue?: () => void
  trigger?: React.ReactNode
  message?: string
  title?: string
}

export function SaveReportModal({ isOpen, onOpenChange, onContinue, trigger, message, title }: SaveReportModalProps) {
  const [open, setOpen] = useState(isOpen || false)

  useEffect(() => {
    setOpen(isOpen ?? false)
  }, [isOpen])

  const handleOpenChange = (open: boolean) => {
    setOpen(open)
    onOpenChange?.(open)
  }

  const handleContinue = () => {
    onContinue?.()
    setOpen(false)
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
      <DialogContent className="sm:max-w-md p-0 border rounded-lg overflow-hidden">
        <div className="p-5 relative">
          <DialogHeader className="text-left p-0 space-y-4">
            <DialogTitle className="text-2xl font-bold">{title || "Save Report"}</DialogTitle>
            <DialogDescription className="text-sm text-foreground">
              {message}
            </DialogDescription>
          </DialogHeader>

          <div className="flex items-center justify-between mt-6">
            <Link to="https://www.raytd.com" target="_blank" rel="noopener noreferrer" className="text-sm underline underline-offset-4 hover:text-primary">
              Learn more about Raytd
            </Link>

            <Button onClick={handleContinue} className="bg-black text-white hover:bg-black/90 rounded-md px-6">
              Continue
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
